import { useEffect, useState } from "react";
import { PRESETS } from "../common/webgl-presets.ts";

const TOTAL = PRESETS.length;

/**
 * Dev-only WebGL background preset switcher.
 * Press Shift+G to cycle through 10 presets.
 * Shows overlay with current preset name + motif.
 */
export function WebGLPresetSwitcher() {
  const [current, setCurrent] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.shiftKey && e.key === "G") {
        e.preventDefault();
        setCurrent((prev) => {
          const next = (prev + 1) % TOTAL;
          window.dispatchEvent(new CustomEvent("webgl-preset-change", { detail: next }));
          return next;
        });
        setVisible(true);
        clearTimeout(hideTimer);
        hideTimer = setTimeout(() => setVisible(false), 3000);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      clearTimeout(hideTimer);
    };
  }, []);

  if (!visible) return null;

  const preset = PRESETS[current];

  return (
    <div
      style={{
        position: "fixed",
        bottom: 60,
        left: "50%",
        transform: "translateX(-50%)",
        background: "rgba(0, 0, 0, 0.85)",
        color: "#fff",
        padding: "10px 20px",
        borderRadius: 8,
        fontSize: 14,
        fontFamily: "monospace",
        zIndex: 9999,
        border: "1px solid rgba(255, 255, 255, 0.15)",
        backdropFilter: "blur(10px)",
        pointerEvents: "none",
        textAlign: "center",
        whiteSpace: "nowrap",
      }}
    >
      <div>
        GL [{preset.id}/{TOTAL}]: {preset.name} ({preset.nameJa})
      </div>
      <div style={{ fontSize: 11, opacity: 0.6, marginTop: 4 }}>{preset.motif}</div>
    </div>
  );
}
